













import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
	components: {}
})
export default class RadioButton extends Vue {
	@Model('input')
	protected readonly checkedValue!: string | null;

	@Prop(String)
	protected readonly value!: string;

	@Prop(String)
	protected readonly name!: string;

	@Prop(String)
	protected readonly label!: string;
}
